import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-form-users',
  templateUrl: './list-form-users.component.html',
  styleUrls: ['./list-form-users.component.css']
})
export class ListFormUsersComponent implements OnInit {
isLoading:boolean = false;
forumData:any
  constructor() { }

  ngOnInit() {
  }
  navigateBAck() {
  }

}
